import { fromNullable } from 'fp-ts/lib/Option';
import { contramap, ordDate } from 'fp-ts/lib/Ord';
import * as platform from 'platform';
import { from, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { dataUrlToBlob, readFiles, readFilesOrData, toRemoteData } from '../utils/axios';
import { getAnonymousName } from '../utils/string.utils';
export var noteDateOrd = contramap(function (note) { return note.updated_at || note.created_at; }, ordDate);
export var noteCreatedDateOrd = contramap(function (note) { return note.created_at; }, ordDate);
var NotesService = /** @class */ (function () {
    function NotesService(axios) {
        this.axios = axios;
    }
    NotesService.prototype.postComment = function (noteId, comment, files, mentions) {
        var _this = this;
        var filesStream = files.length ? from(readFilesOrData(files)) : of([]);
        var data = new FormData();
        data.append('note_id', "" + noteId);
        data.append('text', comment);
        // TODO: remove `browser` and `os`
        var browser = platform.name
            ? platform.name + (platform.version ? ' ' + platform.version : '')
            : 'unknown browser';
        var os = fromNullable(platform.os)
            .mapNullable(function (os) { return (os.family ? os.family + (os.version ? ' ' + os.version : '') : null); })
            .getOrElse('unknown OS');
        data.append("browser", browser);
        data.append("os", os);
        mentions.forEach(function (id, index) {
            data.append("mentions[" + index + "]", "" + id);
        });
        return filesStream.pipe(switchMap(function (files) {
            if (files.length) {
                data.append("attachment", dataUrlToBlob(files[0].data), files[0].name);
            }
            return toRemoteData(_this.axios.post("api/comments", data, { headers: { 'Content-Type': 'multipart/form-data' } }));
        }));
    };
    NotesService.prototype.updateComment = function (commentId, text, _attachments, // tslint:disable-line: variable-name
    _mentions) {
        var data = new FormData();
        data.append('text', text);
        return toRemoteData(this.axios.patch("api/comments/" + commentId, data, { headers: { 'Content-Type': 'multipart/form-data' } }));
    };
    NotesService.prototype.updateNote = function (noteId, text, _attachments, // tslint:disable-line: variable-name
    _mentions) {
        var data = new FormData();
        data.append('text', text);
        return toRemoteData(this.axios.patch("api/notes/" + noteId, data, { headers: { 'Content-Type': 'multipart/form-data' } }));
    };
    NotesService.prototype.addNoteAttachment = function (noteId, att) {
        var _this = this;
        return toRemoteData(readFiles([att]).then(function (att) {
            var data = new FormData();
            data.append('attachments', dataUrlToBlob(att[0].data), att[0].name);
            return _this.axios.patch("api/notes/" + noteId, data, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
        }));
    };
    NotesService.prototype.deleteNoteAttachment = function (noteId, attId) {
        return toRemoteData(this.axios.delete("api/notes/" + noteId + "/attachments/" + attId));
    };
    NotesService.prototype.deleteComment = function (commentId) {
        return toRemoteData(this.axios.delete("api/comments/" + commentId));
    };
    return NotesService;
}());
export { NotesService };
export function createAnonymousUser(hash, name) {
    var data = getAnonymousName(name || hash);
    return {
        name: name || 'Anonymous ' + data.animal,
        profile: {
            avatar: name
                ? undefined
                : "https://www.tinygraphs.com/labs/isogrids/hexa/" + encodeURIComponent(name || data.animal) + "?theme=" + data.colorTheme + "&size=60&numcolors=4",
        },
    };
}
export function isImageAttachment(source) {
    return /\.(png|jpe?g|bmp|gif)/i.test(source);
}
//# sourceMappingURL=notes.service.js.map